import { Pipe, PipeTransform } from '@angular/core';
import { FinanceErrorDetails } from '../../service_ui/dynamicCopy/financialErrors';

@Pipe({name: 'errorLevel'})

export class ErrorLevelPipe implements PipeTransform {
  transform(initialVal: Array<FinanceErrorDetails>) {
      return initialVal.sort((error: FinanceErrorDetails) => {
          return error.level === 'transaction' ? 1 : -1;
      });
  }
}




// WEBPACK FOOTER //
// ./_src/ui/elements/errorLevelPipe.ts